/**
 * DEV-ONLY local auth bypass for clickable UI testing against the simulation Postgres.
 *
 * Active ONLY when BOTH are true:
 *   - this is a Vite dev build (`import.meta.env.DEV`), and
 *   - the Vite process was started with `VITE_DEV_AUTH_BYPASS=1`.
 *
 * Production builds set `import.meta.env.DEV === false` and never define the flag, so this
 * is inert in prod. When active, the app skips Supabase sign-in and sends the API's
 * integration bearer (accepted only when the API runs with `INTEGRATION_TEST=1`), which
 * authenticates as the fixed admin user (role 1 → all hub modules). Pair with the
 * `X-Hub-Data-Source: simulation` header so all operational reads/writes hit the local sim DB.
 *
 * @see src/api/auth.ts `INTEGRATION_TEST_BEARER_TOKEN`
 */
function viteEnv(): Partial<ImportMetaEnv> {
  return (import.meta as ImportMeta & { env?: Partial<ImportMetaEnv> }).env ?? {};
}

export function isDevAuthBypass(): boolean {
  const env = viteEnv();
  return Boolean(env.DEV) && env.VITE_DEV_AUTH_BYPASS === "1";
}

/** Dev preview loads opened by `npm run dev:page-errors`. Ignored in production builds. */
export function isDevPageCheck(): boolean {
  const env = viteEnv();
  if (!env.DEV || typeof window === "undefined") return false;
  return new URLSearchParams(window.location.search).get("hub-page-check") === "1";
}

/** Mirrors the integration-test user in `src/api/auth.ts` (id + bearer the API accepts). */
export const DEV_BYPASS_USER_ID = "00000000-0000-4000-8000-000000000001";
export const DEV_BYPASS_BEARER = "integration-test-bearer";
export const DEV_BYPASS_EMAIL = "integration-test@smartgridsolutions.com";
